/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { FormContainer } from '../index';
import { Box } from '@mui/material';
export const UserForms = (props) => {
  return (
    <Box sx={{ mt: 4 }}>
      <FormContainer
        title="Basic Information"
        longTitle="Address"
        leftTitle="State"
        rightTitle="Country"
        longDefault={props.address}
        leftDefault={props.state}
        rightDefault={props.country}
        onChangeLong={props.onChangeAddress}
        onChangeLeft={props.onChangeState}
        onChangeRight={props.onChangeCountry}
      />
      <FormContainer
        title="Contact Details"
        longTitle="Email"
        leftTitle="Phone Number"
        rightTitle="Telephone"
        longDefault={props.email}
        leftDefault={props.phone}
        rightDefault={props.tel}
        onChangeLong={props.onChangeEmail}
        onChangeLeft={props.onChangePhone}
        onChangeRight={props.onChangeTel}
      />
      <FormContainer
        longRequired={true}
        leftRequired={true}
        rightRequired={true}
        title="Security"
        longTitle="Username"
        leftTitle="New Password"
        rightTitle="Confirm Password"
        leftType="password"
        rightType="password"
        longDefault={props.username}
        onChangeLong={props.onChangeUsername}
        onChangeLeft={props.onChangeNewPass}
        onChangeRight={props.onChangeConfirmPass}
        rightError={props.confirmPassError}
        rightErrorMsg="The password does not match."
      />
    </Box>
  );
};
